import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../AppContext';
import './Alert.css';

const Alert = ({ id, message, type }) => {
  const { removeAlert } = useContext(AppContext);

  useEffect(() => {
    // Component mounted, start fade-out animation
    const alertElement = document.getElementById(`alert-${id}`);
    if (alertElement) {
      alertElement.style.opacity = '1';
    }
  }, [id]);

  const handleDismiss = () => {
    const alertElement = document.getElementById(`alert-${id}`);
    if (alertElement) {
      alertElement.style.opacity = '0';
      setTimeout(() => removeAlert(id), 500); // Wait for fade animation
    }
  };

  return (
    <div 
      id={`alert-${id}`}
      className={`alert alert-${type} ${type === 'invisible' ? 'alert-danger' : ''} alert-dismissible fade show`}
      role="alert"
    >
      {message}
      <button
        type="button"
        className={`btn-close ${type === 'invisible' ? 'invisible' : ''}`}
        onClick={handleDismiss}
        aria-label="Close"
      />
    </div>
  );
};

export default Alert;
export {Alert};